module.exports = __webpack_public_path__ + "static/media/contacts.76d5d895.svg";